import type { Axios } from 'axios'

import type { GivingCampaignOverviewDto } from '../campaign.types'
import { toGsResponse, type GsResponse, type RawResponse } from '../../goodstack'

import type { MutationFn } from '@percent/workplace-giving/common/hooks/useMutation/useMutation.types'

export const publishCampaign: MutationFn<[string], GsResponse<GivingCampaignOverviewDto>> = async (
  client: Axios,
  [campaignId]
) => {
  const response = await client.post<RawResponse<GivingCampaignOverviewDto>>(
    `v1/giving-campaign/${campaignId}/publish`,
    undefined,
    {
      withCredentials: true,
      validateStatus: status => status === 200 || status === 400
    }
  )

  return toGsResponse(response.status, response.data)
}
